<div class="task-item ct-card">
  <app-platform-company-logo
    [companyName]="actionItem().companyName"
    [companyId]="actionItem().companyId"
    [small]="true"
  />
  <div class="details">
    <b class="title">{{ actionItem().jobTitle }}</b>
    <span class="company text-muted">{{ actionItem().companyName }}</span>
    <div class="missing">
      <span class="missing-label text-muted">
        {{ 'jobboard.platform.dashboard.action-items.missing-label' | transloco }}
      </span>
      @for (type of actionItem().missingData; track type) {
        <ct-lib-tag [variant]="TagVariant.GRAY">
          {{ dashboard.missingDataTranslationKey(type) | transloco }}
        </ct-lib-tag>
      }
    </div>
  </div>
  <div class="actions">
    <app-button
      variant="primary"
      [small]="true"
      [iconStart]="icons.apply"
      (click)="openChoice()"
    >
      {{ 'jobboard.platform.apply-with-profile.follow-up-cta' | transloco }}
    </app-button>
  </div>
</div>
